export default {
    title: 'Merge Profiles',
    description:
        'Use the merge tool to combine duplicate records in your database. When you do so, data associated with the two accounts will be merged into a single record.',
    showDuplicates: 'Show Duplicates',
    alert: {
        text: 'Merging profiles is currently limited to a maximum of 2 profiles at a time.',
        learnMore: 'Learn More'
    }
}
